import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ddjqkxjcrjlxyveakcqe.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkanFreGpjcmpseHl2ZWFrY3FlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE1NzA3MDMsImV4cCI6MjA5NzE0NjcwM30.-dJMRKxI0eQMl3OPWXLb1EpfY3wsUHe79rkcZQ349ZU'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})